import React, { useState } from "react";

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phone, message } = formData;
    const whatsappUrl = `https://wa.me/+919730707888?text=Hello%20Aaryan%20Mobility%20LLP%2C%0A%0AName:%20${encodeURIComponent(
      name
    )}%0APhone:%20${encodeURIComponent(
      phone
    )}%0AMessage:%20${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
  <>

<div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Enquiry
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

       

   
  
  
    <section className="enquiry-section">
      <div className="enquiry-card">
        <div className="enquiry-header">
          <img src="/images/logo.jpg" alt="Aaryan Travels" />
          <h2>Quick Enquiry</h2>
          <p>Travel with Luxury and Comfort</p>
        </div>

        <form className="enquiry-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="phone"
              placeholder="Mobile Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your Message / Trip Details"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="enquiry-btn">
            <i className="fa-brands fa-whatsapp"></i> Send Enquiry
          </button>
        </form>
      </div>
    </section>
  </>
  );
};

export default Enquiry;
